
import { LOGIN, USERAUTHCORRECT, CLOSESESSION, SECONDCONFIRM } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LOGIN:
      if(action.payload.data.token) {
        localStorage.setItem('token', action.payload.data.token)
      }

      console.log(action.payload.data.error)
      return{
        ...state,
        errort: action.payload.data.error,
        msg: action.payload.data.error ? action.payload.data.msg : false,
        authentication: action.payload.data.authentication,
      }
    
      case USERAUTHCORRECT:
      return{
        ...state,
        authentication: true,
      }

      case SECONDCONFIRM:
        return({
          ...state,
          errort: action.payload.error,
          msg: action.pay
        })

    case CLOSESESSION:
      localStorage.removeItem('token')
      return{
        ...state,
        authentication: null
      }

    default:
      break;
  }
}